// Ícone de play para thumbnails sem imagem
const PlayIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
    <path d="M8 5.14v14l11-7-11-7z" />
  </svg>
);

export default function ShortsDoClube({ shorts }) {
  // Fica oculto automaticamente se não houver conteúdo
  if (!shorts || shorts.length === 0) return null;

  return (
    <div className="section">
      <div className="secao-header">
        <h2 className="section-title">Shorts do Clube</h2>
        <p className="section-subtitle">Conteúdos rápidos para o seu dia</p>
      </div>

      <div className="shorts-scroll">
        {shorts.map(s => (
          <a
            key={s.id}
            href={s.link}
            target="_blank"
            rel="noopener noreferrer"
            className="short-card"
          >
            <div
              className="short-thumb"
              style={{
                background: s.thumbnail
                  ? `url(${s.thumbnail}) center/cover no-repeat`
                  : 'linear-gradient(160deg, var(--navy) 0%, var(--lavender) 100%)',
              }}
            >
              {!s.thumbnail && (
                <span className="short-play-icon">
                  <PlayIcon />
                </span>
              )}
            </div>
            <p className="short-titulo">{s.titulo}</p>
          </a>
        ))}
      </div>
    </div>
  );
}
